import React from "react";

import Review from "../../../Admin/Customer/Loans/Review";

function BaseDetail({ currentUser }) {
  // NOSONAR

  return <Review currentUser={currentUser} />;
}

export default BaseDetail;
